<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background:
		url('~/assets/images/contentblocks-group22.png') left top no-repeat,
		url('~/assets/images/contentblocks-group21.png') right bottom no-repeat;
	background-color: var(--secondary-background-color);
	padding: 60px 20px;
}
</style>
